import templateUrl from 'emun.filemanager/file-manager.htm'
import controller from 'emun.filemanager/file-manager.controller'
import scss from 'emun.filemanager/file-manager.client.scss'

let FileManager = {
	bindings: {
		realm: '@',
		entityId: '@'
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default FileManager;